module.exports = __webpack_public_path__ + "static/media/around-ter.e98f4edf.jpg";